// Utilities for working with lenses
import { Lens } from "@hookform/lenses";
import { useController } from "react-hook-form";

// Wrapper around useController to provide imperitive set/get for lens values.
// Based on: https://github.com/react-hook-form/react-hook-form/issues/12984
export function useWritableLens<T>(lens: Lens<T>): {
  value: T;
  setValue: (value: T) => void;
  controller: ReturnType<typeof useController>;
} {
  const controller = useController(lens.interop() as any);

  return {
    value: controller.field.value,
    setValue: (value: T) => {
      controller.field.onChange({ target: { value } });
    },
    controller,
  };
}
